/* Data Imports */

import AppConfig from "../../AppConfig";

/* Default Action */

export const defaultAction = () => ({ type: "action" });

export const fetchLogAccessCodes = (func1, func2) => {
  return (dispatch) => {
    dispatch(fetchLogAccessCodesStart());
    return fetch(AppConfig.apiUrlPrefix + "redux-try")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch(fetchLogAccessCodesSuccess(data, func1));
        return data;
      })
      .catch((error) => {
        dispatch(fetchLogAccessCodesError(error, func2));
        return error;
      });
  };
};
export const fetchLogAccessCodesStart = () => ({
  type: "fetchLogAccessCodesStart",
});
export const fetchLogAccessCodesSuccess = (data, func) => {
  func(data);
  return { type: "fetchLogAccessCodesSuccess", payload: data };
};
export const fetchLogAccessCodesError = (error, func) => {
  func(error);
  return { type: "fetchLogAccessCodesError", payload: error };
};

/* ContactForm Action */

export const fetchLeads = (func1, func2) => {
  return (dispatch) => {
    dispatch(fetchLeadsStart());
    return fetch(AppConfig.apiUrlPrefix + "store-lead")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch(fetchLeadsSuccess(data, func1));
        return data;
      })
      .catch((error) => {
        dispatch(fetchLeadsError(error, func2));
        return error;
      });
  };
};
export const fetchLeadsStart = () => ({
  type: "fetchLeadsStart",
});
export const fetchLeadsSuccess = (data, func) => {
  func(data);
  return { type: "fetchLeadsSuccess", payload: data };
};
export const fetchLeadsError = (error, func) => {
  func(error);
  return { type: "fetchLeadsError", payload: error };
};

/* ServiceForm Action */

export const fetchServiceLeads = (func1, func2) => {
  return (dispatch) => {
    dispatch(fetchServiceLeadsStart());
    return fetch(AppConfig.apiUrlPrefix + "store-service-lead")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch(fetchServiceLeadsSuccess(data, func1));
        return data;
      })
      .catch((error) => {
        dispatch(fetchServiceLeadsError(error, func2));
        return error;
      });
  };
};
export const fetchServiceLeadsStart = () => ({
  type: "fetchServiceLeadsStart",
});
export const fetchServiceLeadsSuccess = (data, func) => {
  func(data);
  return { type: "fetchServiceLeadsSuccess", payload: data };
};
export const fetchServiceLeadsError = (error, func) => {
  func(error);
  return { type: "fetchServiceLeadsError", payload: error };
};

/* PostRequirement Action */

export const fetchRequirementLeads = (func1, func2) => {
  return (dispatch) => {
    dispatch(fetchRequirementLeadsStart());
    return fetch(AppConfig.apiUrlPrefix + "store-postrequirement-lead")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch(fetchRequirementLeadsSuccess(data, func1));
        return data;
      })
      .catch((error) => {
        dispatch(fetchRequirementLeadsError(error, func2));
        return error;
      });
  };
};
export const fetchRequirementLeadsStart = () => ({
  type: "fetchRequirementLeadsStart",
});
export const fetchRequirementLeadsSuccess = (data, func) => {
  func(data);
  return { type: "fetchRequirementLeadsSuccess", payload: data };
};
export const fetchRequirementLeadsError = (error, func) => {
  func(error);
  return { type: "fetchRequirementLeadsError", payload: error };
};

/* Single Property */

export const fetchSingleProperty = (slug, func1, func2) => {
  return (dispatch) => {
    dispatch(fetchSinglePropertyStart());
    return fetch(AppConfig.apiUrlPrefix + "properties/" + slug)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch(fetchSinglePropertySuccess(data, func1));
        return data;
      })
      .catch((error) => {
        dispatch(fetchSinglePropertyError(error, func2));
        return error;
      });
  };
};
export const fetchSinglePropertyStart = () => ({
  type: "fetchSinglePropertyStart",
});
export const fetchSinglePropertySuccess = (data, func) => {
  func(data);
  return { type: "fetchSinglePropertySuccess", payload: data };
};
export const fetchSinglePropertyError = (error, func) => {
  func(error);
  return { type: "fetchSinglePropertyError", payload: error };
};

/* Single Property - Data Manager */

export const fetchSinglePropertyDM = (slug, func1, func2) => {
  return (dispatch) => {
    dispatch(fetchSinglePropertyStartDM());
    return fetch(AppConfig.apiUrlPrefix + "data-manager/" + slug)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch(fetchSinglePropertySuccessDM(data, func1));
        return data;
      })
      .catch((error) => {
        dispatch(fetchSinglePropertyErrorDM(error, func2));
        return error;
      });
  };
};
export const fetchSinglePropertyStartDM = () => ({
  type: "fetchSinglePropertyStartDM",
});
export const fetchSinglePropertySuccessDM = (data, func) => {
  func(data);
  return { type: "fetchSinglePropertySuccessDM", payload: data };
};
export const fetchSinglePropertyErrorDM = (error, func) => {
  func(error);
  return { type: "fetchSinglePropertyErrorDM", payload: error };
};

/* Single Blog */

export const fetchSingleBlog = (slug, func1, func2) => {
  return (dispatch) => {
    dispatch(fetchSingleBlogStart());
    return fetch(AppConfig.apiUrlPrefix + "blogs/" + slug)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch(fetchSingleBlogSuccess(data, func1));
        return data;
      })
      .catch((error) => {
        dispatch(fetchSingleBlogError(error, func2));
        return error;
      });
  };
};
export const fetchSingleBlogStart = () => ({
  type: "fetchSingleBlogStart",
});
export const fetchSingleBlogSuccess = (data, func) => {
  func(data);
  return { type: "fetchSingleBlogSuccess", payload: data };
};
export const fetchSingleBlogError = (error, func) => {
  func(error);
  return { type: "fetchSingleBlogError", payload: error };
};

/* Single Stream */

export const fetchSingleStream = (slug, func1, func2) => {
  return (dispatch) => {
    dispatch(fetchSingleStreamStart());
    return fetch(AppConfig.apiUrlPrefix + "stream/" + slug)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch(fetchSingleStreamSuccess(data, func1));
        return data;
      })
      .catch((error) => {
        dispatch(fetchSingleStreamError(error, func2));
        return error;
      });
  };
};
export const fetchSingleStreamStart = () => ({
  type: "fetchSingleStreamStart",
});
export const fetchSingleStreamSuccess = (data, func) => {
  func(data);
  return { type: "fetchSingleStreamSuccess", payload: data };
};
export const fetchSingleStreamError = (error, func) => {
  func(error);
  return { type: "fetchSingleStreamError", payload: error };
};
